class CountdownBlock extends HTMLElement {
  constructor() {
    super()
    /** @type {number | undefined} */
    this.intervalId = undefined
    this.update = this.update.bind(this)
  }

  connectedCallback() {
    this.daysEl = this.querySelector('[data-countdown-days]')
    this.hoursEl = this.querySelector('[data-countdown-hours]')
    this.minutesEl = this.querySelector('[data-countdown-minutes]')
    this.secondsEl = this.querySelector('[data-countdown-seconds]')

    if (!this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl)
      return

    const rawTarget = (this.getAttribute('data-target') || '').trim()
    const normalizedTarget = rawTarget.includes('T')
      ? rawTarget
      : rawTarget.replace(' ', 'T')
    this.targetTime = rawTarget ? Date.parse(normalizedTarget) : NaN

    if (Number.isNaN(this.targetTime)) {
      this.setValues(0, 0, 0, 0)
      return
    }

    if (this.targetTime <= Date.now()) {
      this.setValues(0, 0, 0, 0)
      return
    }

    this.update()
    this.intervalId = window.setInterval(this.update, 1000)
  }

  disconnectedCallback() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId)
      this.intervalId = undefined
    }
  }

  setValues(days, hours, minutes, seconds) {
    const pad = (value) => String(value).padStart(2, '0')

    this.daysEl.textContent = pad(days)
    this.hoursEl.textContent = pad(hours)
    this.minutesEl.textContent = pad(minutes)
    this.secondsEl.textContent = pad(seconds)
  }

  update() {
    const now = Date.now()
    let diff = this.targetTime - now
    if (diff <= 0) {
      this.setValues(0, 0, 0, 0)
      if (this.intervalId) {
        window.clearInterval(this.intervalId)
        this.intervalId = undefined
      }
      return
    }

    const totalSeconds = Math.floor(diff / 1000)
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    this.setValues(days, hours, minutes, seconds)
  }
}

if (!customElements.get('countdown-block')) {
  customElements.define('countdown-block', CountdownBlock)
}
